import React, { useState, useEffect } from 'react';
import BasePage from '../components/BasePage';
import ProgressBar from '../components/ProgressBar';
import FieldsGroup from '../components/FieldsGroup';
import TimeTracker from '../components/TimeTracker';
import PanelAvancement from '../components/Panels/PanelAvancement';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { SquareArrowOutUpRight } from 'lucide-react';
import { faEnvelope, faPhone, faUsers } from '@fortawesome/free-solid-svg-icons';


const Avancement = (props) => {

    const fields_groups = [
        {
            key: 'start',
            name: 'Mise en place',
            icon: 'fa-globe fa-solid',
            fields: [
                {
                    key: 'partenariat',
                    name: 'Mon contrat',
                    classes: 'timeline-item'
                }, {
                    key: 'user',
                    name: 'Collaborateur',
                    format: 'user'
                }
            ]
        }, {
            key: 'steps',
            name: 'Conception',
            icon: 'fa-solid fa-laptop-code',
            fields: []
        }, {
            key: 'suiviclient',
            name: 'Suivi Client',
            icon: 'fa-solid fa-headphones-simple',
            fields: []
        }
    ]

    const content = (data) => {

        console.log('Données avancement :', data);

//         let steps = fields_groups.find((e) => e.key == 'steps')
//         steps.fields = []
//         // Object.entries(data.steps).reverse().map(([stepKey, step], index) => {
//         //     steps.fields.push({ key: stepKey, name: step.title, classes: 'border-no mt-5 timeline-item',  })
//         //     steps.fields.push({ key: stepKey + '.user', name: 'Collaborateur', format: 'user' })
//         // })
//         if (data.avancement_packs && Object.keys(data.avancement_packs).length > 0) {
//     Object.entries(data.avancement_packs).forEach(([colonne, items]) => {
//         items.forEach((item, index) => {
//             steps.fields.push({
//                 key: `pack-${colonne}-${index}`,
//                 name: item.name,
//                 value: item.dateIn ? `Entrée le ${new Date(item.dateIn).toLocaleDateString()}` : null,
//                 classes: 'border-no mt-5 timeline-item',
//             });
//         });
//     });
// } else {
//     Object.entries(data.steps).reverse().forEach(([stepKey, step]) => {
//         steps.fields.push({ key: stepKey, name: step.title, classes: 'border-no mt-5 timeline-item' });
//         steps.fields.push({ key: stepKey + '.user', name: 'Collaborateur', format: 'user' });
//     });
// }

//         // Traitement du suivi client
//         let suiviclient = fields_groups.find((e) => e.key == 'suiviclient');
//         suiviclient.fields = [];

//         if (Object.keys(data.suiviclient).length === 0) {
//             suiviclient.fields.push({
//                 key: 'no-data',
//                 name: 'Suivi Client',
//                 value: 'Aucun suivi client pour le moment.',
//                 format: 'text',
//                 classes: 'italic text-gray-500'
//             });
//         } else {
//             Object.entries(data.suiviclient)
//                 .sort(([, a], [, b]) => new Date(b.date) - new Date(a.date)) // tri décroissant
//                 .map(([stepKey, suivi], index) => {
//                 let icon = null;
//                 if (suivi.title.toLowerCase().includes('mail')) {
//                     icon = <FontAwesomeIcon icon={faEnvelope} />;
//                 } else if (suivi.title.toLowerCase().includes('téléphonique')) {
//                     icon = <FontAwesomeIcon icon={faPhone} />;
//                 } else {
//                     icon = <FontAwesomeIcon icon={faUsers} />;
//                 }
//                 suiviclient.fields.push({
//                     key: stepKey,
//                     date: suivi.date,
//                     name: suivi.title,
//                     format: 'rdv',
//                     icon: icon,
//                     classes: 'border-no mt-5 timeline-item'
//                 });
//                 suiviclient.fields.push({
//                     key: stepKey + '.user',
//                     name: 'Collaborateur',
//                     format: 'user'
//                 });
//             });
//         }

 // ======== STEPS (packs ou legacy, même affichage) ========
    const stepsGroup = fields_groups.find((e) => e.key === 'steps');
    stepsGroup.fields = [];

    const entries = Object.entries(data.steps || {}); 

    entries.forEach(([stepKey, step]) => {
      stepsGroup.fields.push({
        key: stepKey,
        name: step.title,
        value: step.task_txt ?? null, // ex: "Terminé le …", "En cours …"
        classes: 'border-no mt-5 timeline-item',
      });

      // Afficher "Collaborateur" uniquement si défini
      if (step.user) {
        stepsGroup.fields.push({
          key: `${stepKey}.user`,
          name: 'Collaborateur',
          format: 'user',
        });
      }
    });

    // ======== SUIVI CLIENT ========
    const suiviclient = fields_groups.find((e) => e.key === 'suiviclient');
    suiviclient.fields = [];

    const hasSuivi = data.suiviclient && Object.keys(data.suiviclient).length > 0;

    if (!hasSuivi) {
      suiviclient.fields.push({
        key: 'no-data',
        name: 'Suivi Client',
        value: 'Aucun suivi client pour le moment.',
        format: 'text',
        classes: 'italic text-gray-500',
      });
    } else {
      Object.entries(data.suiviclient)
        .sort(([, a], [, b]) => new Date(b.date) - new Date(a.date))
        .forEach(([stepKey, suivi]) => {
          const title = (suivi.title || '').toLowerCase();
          let icon = <FontAwesomeIcon icon={faUsers} />;
          if (title.includes('mail')) icon = <FontAwesomeIcon icon={faEnvelope} />;
          if (title.includes('téléphonique') || title.includes('telephonique')) icon = <FontAwesomeIcon icon={faPhone} />;

          suiviclient.fields.push({
            key: stepKey,
            date: suivi.date,
            name: suivi.title,
            format: 'rdv',
            icon,
            classes: 'border-no mt-5 timeline-item',
          });

          if (suivi.user) {
            suiviclient.fields.push({
              key: `${stepKey}.user`,
              name: 'Collaborateur',
              format: 'user',
            });
          }
        });
    }


        // Utilisez la variable data récupérée dans BasePage ici
        // Par exemple, vous pouvez afficher les données ou effectuer toute autre logique avec elles
        return (
            <div id="avancement">
                <div className="bloc-info p-10 mb-8 mt-8 flex gap-4 items-center justify-between">
                    <div className='w-1/2'>
                        <FontAwesomeIcon className="text-mlime text-3xl mr-4" icon="fa-solid fa-display" />
                        <Link to={`https://${data.ndd}`} target="_blank" className="font-bold text-lg">
                            {data.ndd}
                        </Link>
                    </div>
                    <div className='w-1/2 bloc-info'>
                        <TimeTracker compteur={data.compteur_temps} />
                    </div>
                </div>

                <FieldsGroup fields_groups={fields_groups} data={data} timeline={true} />

                <div className="mt-8 flex justify-center">
                    <Link to={`https://${data.ndd}`} target="_blank" className="bg-mlime px-10 py-5 font-bold rounded-3xl max-w-lg duration-500 hover:bg-colorbutton text-white">
                        <SquareArrowOutUpRight className='text-sm inline-flex mr-2'/>
                        Mon Site
                    </Link>
                </div>
            </div>
        );
    };

    return <BasePage content={content} title={props.title ?? null} />
}

export default Avancement;